import { useNavigate, useRouter } from "@tanstack/react-router";
import { ChevronLeftIcon } from "lucide-react";

import { Button } from "@/components/button";
import { Skeleton } from "@/components/skeleton";

export function HeaderSkeleton() {
  const { history } = useRouter();
  const navigate = useNavigate();

  return (
    <header className="static md:top-0 z-10 sm:static sm:z-auto flex gap-lg flex-col">
      <div className="flex flex-col gap-lg lg:flex-row lg:items-center lg:px-3xl lg:pt-xl lg:gap-2xl">
        <div className="px-3xl pt-xl lg:px-0 lg:pt-0 flex flex-1 min-w-0 justify-start items-center gap-2xl">
          <Button
            color="gray"
            isIconOnly
            onPress={() =>
              history.canGoBack()
                ? history.go(-1)
                : navigate({ search: { filter: "all" }, to: "/requests" })
            }
            size="lg"
            variant="secondary"
          >
            <ChevronLeftIcon size={20} />
          </Button>
          <div className="inline-flex w-full flex-col justify-start items-start gap-xs">
            <Skeleton className="h-8 w-64 max-w-full rounded-md" />
            <Skeleton className="hidden sm:block h-4 w-56 max-w-full" />
          </div>
        </div>

        <div className="px-md md:px-3xl lg:px-0 inline-flex flex-wrap lg:flex-nowrap justify-center items-center gap-1 lg:gap-sm w-full lg:w-fit">
          <Skeleton className="h-9 w-28 rounded-lg" />
          <Skeleton className="h-9 w-32 rounded-lg" />
          <Skeleton className="h-9 w-24 rounded-lg" />
        </div>
      </div>

      <div className="inline-flex justify-start items-center gap-lg px-3xl pt-lg pb-2xl border-b border-border-primary overflow-x-auto scrollbar-none">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="flex items-center gap-2 shrink-0" key={index}>
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-6 w-24 rounded-full" />
          </div>
        ))}
      </div>
    </header>
  );
}
